export default {
    getResults: function (startDate, endDate, facilityList) {
        return fetch("/api/results", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ StartDate: endDate.toISOString(), EndDate: startDate.toISOString(), FacilityIdList: facilityList })
    });
  },
  acknowledgeCriticals: function (criticalIds, environmentalSourceMRN, facilityCd) {
      return fetch("/api/acknowledge-criticals",
         {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ criticalIds, environmentalSourceMRN, facilityCd })
         });
    },
    addUpdateResults: function (patientOrderId, results) {        
        return fetch("/api/addupdateresults",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ PatientOrderId:patientOrderId, Results : results })
            });
    },
    getResultTemplate: function (resultTemplateId, facilityid, patientid, envsourceid, collectionDate) {
        alert('resulttemplate2' + JSON.stringify({ resultTemplateId, facilityid, patientid, envsourceid, collectionDate }));
        return fetch("/api/getresulttemplates",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ resultTemplateId, facilityid, patientid, envsourceid, collectionDate })
            });
    }


};
